export default __webpack_public_path__ + "static/media/COSTAL25.4483b9ec.png";